import { lazy } from 'react'
import type { RouteObject } from 'react-router'
const PagePlanning = lazy(() => import('./PagePlanning').then((m) => ({ default: m.PagePlanning })))
export const routesPlanning: RouteObject[] = [{ index: true, element: <PagePlanning /> }]
